import * as types from '../../../actions/types';

const initialState = {}

export default function eioc (state = initialState, action) {
  switch (action.type) {
    case types.SET_DASHBOARD_DETAILS_EIOC:
      return action.payload

    default:
      return state;
  }
}
